var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-banner',{attrs:{"banners":_vm.banners}}),_c('video-list',{attrs:{"videoList":_vm.videoList}}),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }